import React, { Component } from "react";
import { connect } from "react-redux";
import { Box, Checkbox, Radio, Typography } from "@mui/material";

class SelectableChip extends Component {
    onPress = () => {
        const { disabled, onPress } = this.props;

        if (disabled) {
            window.alert("Daten können nicht entfernt werden.");
            return;
        }

        onPress?.();
    };

    render() {
        const {
            label,
            children,
            style,
            value,
            singleMode,
            disabled
        } = this.props;

        return (
            <Box
                onClick={this.onPress}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    border: "0.5px solid #D3D3D3",
                    borderRadius: "10px",
                    padding: "10px 12px",
                    cursor: disabled ? "not-allowed" : "pointer",
                    userSelect: "none",
                    backgroundColor: "#fff",
                    opacity: disabled ? 0.7 : 1,
                    width: "100%",
                    minWidth: 0,
                    boxSizing: "border-box",
                    overflow: "hidden",
                    ...style
                }}
            >
                <Box
                    sx={{
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    {singleMode ? (
                        <Radio
                            checked={!!value}
                            onChange={this.onPress}
                            disabled={disabled}
                            sx={{
                                color: "#979797",
                                "&.Mui-checked": {
                                    color: "#979797"
                                },
                                padding: 0
                            }}
                        />
                    ) : (
                        <Checkbox
                            checked={!!value}
                            onChange={this.onPress}
                            disabled={disabled}
                            sx={{
                                color: "#3C3C3C",
                                "&.Mui-checked": {
                                    color: "#3C3C3C"
                                },
                                padding: 0
                            }}
                        />
                    )}
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        overflow: "hidden"
                    }}
                >
                    {children != null ? (
                        children
                    ) : (
                        <Typography
                            sx={{
                                color: "#353535",
                                fontSize: "0.95rem",
                                minWidth: 0,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}
                        >
                            {label}
                        </Typography>
                    )}
                </Box>
            </Box>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(SelectableChip);